/**
 * Plant Spacing Calculator — TypeScript entry point.
 * Handles plant preset selection, scroll-to-results, and hidden-iframe print flow.
 */
import { initIframePrint } from './shared/iframe-print';

function updateSpacing(value: string): void {
    if (value) {
        const spacingInput = document.querySelector<HTMLInputElement>('[name="PlantSpacing"]');
        const spacingUnitSelect = document.querySelector<HTMLSelectElement>('[name="SpacingUnit"]');

        if (spacingInput) {
            spacingInput.value = value;
        }

        if (spacingUnitSelect) {
            spacingUnitSelect.value = 'inches';
        }
    }
}

function init(): void {
    initIframePrint({
        formId: 'pscPrintForm',
        iframeId: 'pscPrintFrame',
        buttonId: 'pscPrintBtn',
        readyLabel: '<i class="bi bi-printer me-2" aria-hidden="true"></i>Print Planting Guide',
    });

    const plantPresetSelect = document.getElementById('plantPreset') as HTMLSelectElement | null;
    if (plantPresetSelect) {
        plantPresetSelect.addEventListener('change', function (this: HTMLSelectElement) {
            updateSpacing(this.value);
        });
    }

    const resultsSection = document.getElementById('plant-results');
    if (resultsSection) {
        window.requestAnimationFrame(() => {
            resultsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
    }

    const resetBtn = document.getElementById('btn-calculate-another');
    if (resetBtn) {
        resetBtn.addEventListener('click', () => {
            window.location.href = window.location.pathname;
        });
    }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
